/**
 *
 * Hero with Full Image
 *
 * Handling full width
 */

jQuery(document).ready(function ($) {
    const block = $('.itbl-b-hero-full-image');

    if(!block.length) {
        return;
    }

    setWidthAll(block);

    function setWidthAll() {
        block.each(function(i, element) {
            setWidth(element);
        });
    }

    function setWidth(element) {
        // get document width
        const documentWidth = $(document).width();

        // get entry-content width
        const entryContentWidth = $('.entry-content').width();

        $(element).css('margin-left', (entryContentWidth - documentWidth) / 2 + 'px');
        $(element).css('width', documentWidth + 'px');
    }

    // on screen resize
    $(window).on('resize', function() {
        setWidthAll();
    });
});
